import { isCommunityInstallPath } from '../PWA/pwaPromptConfig';

const DEFAULT_THEME_COLOR = '#000000';

interface ResolvePwaHeadConfigArgs {
  pathname: string;
  communityPwaEnabled: boolean | undefined;
  publicationPwaEnabled: boolean | undefined;
}

interface ResolveThemeColorArgs {
  isCommunityPwaEnabled: boolean;
  communityPrimaryColor: string | undefined;
  publicationBackgroundColor: string | undefined;
}

export interface PwaHeadConfig {
  isCommunityPwaEnabled: boolean;
  isPublicationPwaEnabled: boolean;
  isPwaInstallPromptEnabled: boolean;
  showCommunityManifest: boolean;
  showPublicationManifest: boolean;
}

export const resolvePwaHeadConfig = ({
  pathname,
  communityPwaEnabled,
  publicationPwaEnabled,
}: ResolvePwaHeadConfigArgs): PwaHeadConfig => {
  const isCommunityRoute = isCommunityInstallPath(pathname);
  const isCommunityPwaEnabled = isCommunityRoute && Boolean(communityPwaEnabled);
  const isPublicationPwaEnabled = !isCommunityRoute && Boolean(publicationPwaEnabled);

  return {
    isCommunityPwaEnabled,
    isPublicationPwaEnabled,
    isPwaInstallPromptEnabled: isCommunityPwaEnabled || isPublicationPwaEnabled,
    showCommunityManifest: isCommunityPwaEnabled,
    showPublicationManifest: isPublicationPwaEnabled,
  };
};

export const resolveThemeColor = ({
  isCommunityPwaEnabled,
  communityPrimaryColor,
  publicationBackgroundColor,
}: ResolveThemeColorArgs): string =>
  isCommunityPwaEnabled
    ? (communityPrimaryColor ?? DEFAULT_THEME_COLOR)
    : (publicationBackgroundColor ?? DEFAULT_THEME_COLOR);
